var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-5" },
    [
      _c(
        "el-row",
        { staticClass: "bg-white" },
        [
          _c("el-col", { attrs: { span: 16 } }, [
            _c(
              "div",
              { staticClass: "pl-20 pt-10 pb-10 l-b fs-a1" },
              [
                _vm._v("\n        公众号配置\n        "),
                _vm.form.account_appid
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          to:
                            "/shop/replySet?appid=" +
                            _vm.form.account_appid +
                            "&store_id=" +
                            _vm.id,
                          target: "_blank",
                        },
                      },
                      [
                        _c(
                          "el-link",
                          {
                            staticClass: "ml-20 fs-c1",
                            attrs: { target: "_blank", type: "primary" },
                          },
                          [_vm._v("关注回复配置")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pt-30 pl-30" },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      model: _vm.form,
                      "label-width": "200px",
                      "label-position": "left",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "公众号名称：" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.account_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "account_name", $$v)
                            },
                            expression: "form.account_name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "关注引导语：" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.leading_words,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "leading_words", $$v)
                            },
                            expression: "form.leading_words",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "公众号标识(APPID)：" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.account_appid,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "account_appid", $$v)
                            },
                            expression: "form.account_appid",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "原始ID(original_id)：" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.original_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "original_id", $$v)
                            },
                            expression: "form.original_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "公众号APPSECRET：" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.account_appsecret,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "account_appsecret", $$v)
                            },
                            expression: "form.account_appsecret",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "服务器地址：" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.account_url,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "account_url", $$v)
                            },
                            expression: "form.account_url",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "令牌(token)：" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.account_token,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "account_token", $$v)
                            },
                            expression: "form.account_token",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "消息加解密密钥：" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.EncodingAESKey,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "EncodingAESKey", $$v)
                            },
                            expression: "form.EncodingAESKey",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "关注链接：" } },
                      [
                        _c(
                          "el-input",
                          {
                            model: {
                              value: _vm.form.follow_http,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "follow_http", $$v)
                              },
                              expression: "form.follow_http",
                            },
                          },
                          [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  slot: "append",
                                  placement: "top-start",
                                  title: "关注链接",
                                  width: "300",
                                  trigger: "hover",
                                  content:
                                    "小程序关联的公众号中添加一篇引导关注的文章,将文章链接填入此即可",
                                },
                                slot: "append",
                              },
                              [
                                _c("el-button", {
                                  attrs: {
                                    slot: "reference",
                                    icon: "el-icon-question",
                                  },
                                  slot: "reference",
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "加密模式：" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.form.encryption_method,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "encryption_method", $$v)
                              },
                              expression: "form.encryption_method",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "明文模式", value: "text" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: {
                                label: "兼容模式",
                                value: "compatibility",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "安全模式", value: "security" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "免费充电次数：" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.free_order_num,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "free_order_num", $$v)
                            },
                            expression: "form.free_order_num",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "校验用户是否关注：" } },
                      [
                        _c("el-switch", {
                          attrs: { "active-value": 1, "inactive-value": 0 },
                          model: {
                            value: _vm.form.check_user_right,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "check_user_right", $$v)
                            },
                            expression: "form.check_user_right",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "关注免费充电：" } },
                      [
                        _c("el-switch", {
                          attrs: { "active-value": 1, "inactive-value": 0 },
                          model: {
                            value: _vm.form.free_order_switch,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "free_order_switch", $$v)
                            },
                            expression: "form.free_order_switch",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "状态：" } },
                      [
                        _c("el-switch", {
                          attrs: { "active-value": 1, "inactive-value": 0 },
                          model: {
                            value: _vm.form.follow_open,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "follow_open", $$v)
                            },
                            expression: "form.follow_open",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.onSubmit },
                          },
                          [_vm._v("提交")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }